import { useContext } from 'preact/hooks';

import type { DialogButtonTemplateParams } from 'Components/smallComponents/dialogButton';
import type { TemplateFunction, TemplateResult } from 'Components/types';
import { cloneSafe } from 'Utils/components';
import { simpleHandler } from 'Utils/roleHandler';

import VehicleWidget from '../../vehicleWidget/index';
import type { VehicleWidgetTemplateParams } from '../../vehicleWidget/vehicleWidget';
import AddButton from '../addButton';
import { vehicleWidgetName } from '../garage';
import GarageContext from '../garageContext';

interface Props {
  template: TemplateFunction<EmptyDropdownTemplateParams>;
}

export interface EmptyDropdownTemplateParams {
  addButton: (templ: TemplateFunction<DialogButtonTemplateParams>) => TemplateResult;
  closeGarage?: () => void;
  vehicleWidget: (templ: TemplateFunction<VehicleWidgetTemplateParams>) => TemplateResult;
  template: 'empty';
}

export default function EmptyDropdown({ template }: Props): TemplateResult {
  const {
    closeGarage,
    doNotRedirectOnVehicleSelect,
    isAutoVehicleSelectionDisabled,
    redirectUrl,
    showVehicleDropdowns,
    useNativeDropdown,
    useVehicleWidget,
  } = useContext(GarageContext);

  const addButton = (templ: TemplateFunction<DialogButtonTemplateParams>) => (
    <AddButton template={templ} key="add" />
  );

  const onClick = simpleHandler({ showVehicleDropdowns });

  const vehicleWidget = (templ: TemplateFunction<VehicleWidgetTemplateParams>) => {
    if (!useVehicleWidget) {
      return null;
    }

    const props = {
      isAlwaysActive: true,
      isAlwaysColumnLayout: true,
      isAutoVehicleSelectionDisabled,
      name: vehicleWidgetName,
      doNotRedirectOnVehicleSelect,
      redirectUrl,
      useNativeDropdown,
      template: templ,
    };
    return <VehicleWidget {...props} key="VehicleWidget" />;
  };

  const component = template.call({ addButton, closeGarage, vehicleWidget, template: 'empty' });
  return cloneSafe(component, null, { onClick });
}
